interface DecimalOptions {
  minimumFractionDigits?: number;
  maximumFractionDigits?: number;
  /** Rounds to significant digits instead of places ("0.00432"). */
  maximumSignificantDigits?: number;
}

let decimalCache: Map<string, Intl.NumberFormat> | undefined;

/**
 * A number grouped with thousands separators and rounded by `Intl` to the
 * places (or significant digits) asked: "1,234.57", "0.00432". The figure a
 * screen prints with `toLocaleString('en-US', options)`. For a token amount
 * in base units use `formatUnitsFixed`, which rounds the exact amount.
 */
export function formatDecimal(
  value: number,
  options: DecimalOptions = {}
): string {
  const key = `${options.minimumFractionDigits}|${options.maximumFractionDigits}|${options.maximumSignificantDigits}`;
  decimalCache ??= new Map();
  let formatter = decimalCache.get(key);
  if (!formatter) {
    formatter = new Intl.NumberFormat('en-US', options);
    decimalCache.set(key, formatter);
  }
  return formatter.format(value);
}
